import React from 'react';
import { toast } from 'react-toastify';
import Toast from '../Components/Toast/Toast';

export const triggerToast = ({ title, text, type }) => {
  toast(<Toast title={title} text={text} type={type} />, {
    position: 'bottom-right',
    autoClose: 5000,
  });
};
